import Map from './views/Map.vue';

export default [
  { path: '/:visible?/:schlagId?', name: 'map', component: Map },
];
